import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALRUMIJA,
  DELETE_LEGALRUMIJA,
  UPDATE_LEGALRUMIJA,
  ADD_NEW_LEGALRUMIJA,
} from "./actionType";

import {
  getLegalRumijaSuccess,
  getLegalRumijaFail,
  deleteLegalRumijaSuccess,
  deleteLegalRumijaFail,
  updateLegalRumijaSuccess,
  updateLegalRumijaFail,
  addLegalRumijaSuccess,
  addLegalRumijaFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLegalRumijaApi,
  updateLegalRumijaApi,
  deleteLegalRumijaApi,
  addNewLegalRumijaApi
} from "../../helpers/backend_helper";

function* getLegalRumija({ payload: legalRumija }) {
  try {
    const response = yield call(getLegalRumijaApi, legalRumija);
    yield put(getLegalRumijaSuccess(GET_LEGALRUMIJA, response.data));
  } catch (error) {
    yield put(getLegalRumijaFail(GET_LEGALRUMIJA, error));
  }
}

function* onUpdateLegalRumija({ payload: legalRumija }) {
  try {
    const response = yield call(updateLegalRumijaApi, legalRumija);
    yield put(updateLegalRumijaSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateLegalRumijaFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalRumija({ payload: legalRumija }) {
  try {
    const response = yield call(deleteLegalRumijaApi, legalRumija);
    yield put(deleteLegalRumijaSuccess({ legalRumija, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalRumijaFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalRumija({ payload: legalRumija }) {
  try {
    const response = yield call(addNewLegalRumijaApi, legalRumija);
    yield put(addLegalRumijaSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalRumijaFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalRumija() {
  yield takeEvery(GET_LEGALRUMIJA, getLegalRumija);
}

export function* watchUpdateLegalRumija() {
  yield takeEvery(UPDATE_LEGALRUMIJA, onUpdateLegalRumija);
}

export function* watchDeleteLegalRumija() {
  yield takeEvery(DELETE_LEGALRUMIJA, onDeleteLegalRumija);
}

export function* watchAddNewLegalRumija() {
  yield takeEvery(ADD_NEW_LEGALRUMIJA, onAddNewLegalRumija);
}

function* legalRumijaSaga() {
  yield all([
    fork(watchGetLegalRumija),
    fork(watchDeleteLegalRumija),
    fork(watchUpdateLegalRumija),
    fork(watchAddNewLegalRumija)
  ]);
}

export default legalRumijaSaga;
